import React from 'react';
import { CheckCircle, Award, Users, Clock, Shield } from 'lucide-react';
import { companyInfo } from '../data/mock';

const AboutSection = () => {
  const features = [
    {
      icon: Award,
      text: 'Echipă de detectivi licențiați IGPR'
    },
    {
      icon: Shield,
      text: 'Tehnologie profesională de investigații'
    },
    {
      icon: Users,
      text: 'Rapoarte detaliate cu dovezi legale'
    },
    {
      icon: Clock,
      text: 'Confidențialitate garantată prin contract'
    },
    {
      icon: CheckCircle,
      text: 'Consultanță gratuită inițială'
    }
  ];

  const stats = [
    { value: companyInfo.casesResolved, label: 'Cazuri Rezolvate' },
    { value: companyInfo.satisfactionRate, label: 'Rată Succes' },
    { value: companyInfo.experience, label: 'Experiență' },
    { value: '24/7', label: 'Disponibilitate' }
  ];

  return (
    <section 
      id="despre" 
      className="py-24 bg-slate-900"
      aria-labelledby="about-heading"
      itemScope
      itemType="https://schema.org/AboutPage"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <article>
            <span className="text-amber-400 text-sm uppercase tracking-wider mb-3 block font-semibold">
              Despre Detectivi Bacau
            </span>
            <h2 
              id="about-heading"
              className="text-3xl md:text-4xl font-bold text-white mb-6"
              itemProp="name"
            >
              Experiență și Profesionalism în Investigații Private
            </h2>
            
            <p className="text-slate-300 leading-relaxed mb-6" itemProp="description">
              Cu peste <strong className="text-white">{companyInfo.experience}</strong> de experiență 
              în domeniul investigațiilor private, echipa noastră de detectivi particulari profesioniști 
              vă oferă servicii de cea mai înaltă calitate în Bacău și în întreaga Românie.
            </p>
            
            <p className="text-slate-400 mb-8">
              Fiecare caz este tratat cu maximă discreție și profesionalism. Suntem specializați în 
              verificări fidelitate, teste poligraf (detector de minciuni), detectare camere spion și microfoane, 
              precum și background check pentru companii. Ne mândrim cu o rată de succes de {companyInfo.satisfactionRate}.
            </p>

            {/* Features List */}
            <div className="space-y-4">
              {features.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div key={index} className="flex items-center gap-4 group">
                    <div className="w-10 h-10 rounded-lg bg-amber-500/10 flex items-center justify-center group-hover:bg-amber-500/20 transition-colors">
                      <IconComponent className="w-5 h-5 text-amber-400" aria-hidden="true" />
                    </div>
                    <span className="text-slate-300">{item.text}</span>
                  </div>
                );
              })}
            </div>
          </article>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat, index) => (
              <div 
                key={index}
                className="bg-slate-800/50 border border-slate-700/50 rounded-2xl p-6 text-center hover:border-amber-500/30 transition-colors"
              >
                <div className="text-3xl md:text-4xl font-bold text-white mb-2">
                  {stat.value}
                </div>
                <div className="text-slate-400 text-sm">
                  {stat.label}
                </div>
              </div>
            ))}
            
            {/* License Badge */}
            <div className="col-span-2 bg-gradient-to-r from-amber-500/10 to-amber-600/10 border border-amber-500/30 rounded-2xl p-6">
              <div className="flex items-center justify-center gap-4">
                <div className="w-12 h-12 rounded-full bg-amber-500/20 flex items-center justify-center">
                  <Shield className="w-6 h-6 text-amber-400" aria-hidden="true" />
                </div>
                <div className="text-left">
                  <h3 className="text-white font-semibold">Agenție Licențiată IGPR</h3>
                  <p className="text-amber-400/80 text-sm">Toate investigațiile sunt legale și dovezile admisibile în instanță</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
